export enum DocumentType {
  SYS_CONDITIONS_GENERALES = 'SYS_CONDITIONS_GENERALES',
  SYS_CONDITIONS_SPECIALES = 'SYS_CONDITIONS_SPECIALES',
  SYS_NOTICE_INFORMATION = 'SYS_NOTICE_INFORMATION',
  SYS_FICHE_PRODUIT = 'SYS_FICHE_PRODUIT'
}

// Interface pour la catégorie de document
export interface DocumentCategory {
  id: number;
  code: DocumentType;
  label: string;
  description?: string;
}

// Interface pour le fichier stocké
export interface StoredFile {
  id: string;
  fileName: string;
  fileSize: number;
  mimeType: string;
  uploadDate: string;
  storagePath?: string;
}

// Interface pour le document principal
export interface Document {
  id: string;
  title: string;
  version: string;
  createdDate: string;
  updatedDate: string;
  categorie: DocumentCategory;
  storedFile: StoredFile;
  storedFileId: string;
}

// Interface pour le document contractuel (celui retourné par l'API)
export interface ContractualDocument {
  id: string;
  productId: string;
  document: Document;
  isGroup: boolean;
  isRequired: boolean;
  displayOrder: number;
  validFrom?: string;
  isActive: boolean;
  validTo?: string;
}

// Interface pour la réponse de l'API
export interface ContractualDocumentsResponse {
  documents: ContractualDocument[];
  totalCount: number;
  productId: string;
}

// Type pour les paramètres de recherche
export interface DocumentSearchParams {
  productId: string;
  documentType?: DocumentType;
  isGroup?: boolean;
  isActive?: boolean;
}

// Interface pour les erreurs de document
export interface DocumentError {
  code: string;
  message: string;
  documentType?: DocumentType;
  productId?: string;
}

// Types utilitaires
export type DocumentDownloadResult = {
  success: boolean;
  fileName?: string;
  error?: DocumentError;
};

export type DocumentTypeLabel = {
  [key in DocumentType]: string;
};

// Labels pour l'affichage
export const DOCUMENT_TYPE_LABELS: DocumentTypeLabel = {
  [DocumentType.SYS_CONDITIONS_GENERALES]: 'Conditions Générales',
  [DocumentType.SYS_CONDITIONS_SPECIALES]: 'Fiche Produit', // temporaire ... 
  [DocumentType.SYS_NOTICE_INFORMATION]: 'Notice d\'Information',
  [DocumentType.SYS_FICHE_PRODUIT]: 'Fiche Produit'
};

// Fonction utilitaire pour vérifier si un document existe
export const isDocumentAvailable = (
  documents: ContractualDocument[],
  type: DocumentType,
  isGroup: boolean
): boolean => {
  return documents.some(doc =>
    doc.document?.categorie?.code === type &&
    doc.isGroup === isGroup &&
    doc.isActive === true
  );
};

// Fonction utilitaire pour filtrer les documents par type
export const getDocumentsByType = (
  documents: ContractualDocument[],
  type: DocumentType
): ContractualDocument[] => {
  return documents.filter(doc =>
    doc.document?.categorie?.code === type &&
    doc.isActive === true
  );
};
